import { useEffect, useRef, useState } from 'react';
import { ModifiersListView } from 'root/consts';
import { useItemsDisplayValues } from 'root/hooks/useItemsDisplayValues';
import type { ModifierGroup } from 'root/apiTypes';
import { useTranslation } from '@wix/yoshi-flow-editor';

export const useModifierGroupsLogic = (modifierGroups: ModifierGroup[]) => {
  const { modifierGroupTitleHtmlTag, modifiersListView: modifierListView } = useItemsDisplayValues();
  const { t } = useTranslation();
  const isModifierListCollapsed = modifierListView === ModifiersListView.Collapse;
  const [isCollapsed, setIsCollapsed] = useState(isModifierListCollapsed);
  const firstShowMoreElementRef = useRef<HTMLDivElement>(null);
  const shouldRefFocus = (modifierGroupIndex: number, modifierIndex?: number) => {
    if (modifierGroups[0].modifiers?.length > 3) {
      if (modifierGroupIndex === 0 && modifierIndex === 3) {
        return true;
      }
    } else if (modifierGroupIndex === 1 && modifierIndex === undefined) {
      return true;
    }
    return false;
  };
  useEffect(() => {
    setIsCollapsed(isModifierListCollapsed);
  }, [isModifierListCollapsed]);

  const onChangeShowButton = () => {
    const newCollapsedState = !isCollapsed;
    setIsCollapsed(newCollapsedState);
    if (!newCollapsedState) {
      requestAnimationFrame(() => {
        firstShowMoreElementRef?.current?.focus();
      });
    }
  };
  const showButtonText = isCollapsed
    ? t('app.widget.modifier-groups.show-button.more-text')
    : t('app.widget.modifier-groups.show-button.less-text');
  const shouldShowModifierGroup = (modifierGroupIndex: number) => !isCollapsed || modifierGroupIndex === 0;
  const shouldShowModifier = (modifierIndex: number) => !isCollapsed || modifierIndex < 3;
  const shouldShowShowButton =
    (modifierGroups.length > 1 || modifierGroups[0].modifiers?.length > 3) && isModifierListCollapsed;
  return {
    modifierGroupTitleHtmlTag,
    showButtonText,
    onChangeShowButton,
    isCollapsed,
    modifierListView,
    shouldShowModifierGroup,
    shouldShowModifier,
    shouldShowShowButton,
    shouldRefFocus,
    firstShowMoreElementRef,
  };
};
